import * as React from 'react';
import PropTypes from 'prop-types';

import { toast } from 'react-hot-toast';
import useInput from '../hooks/useInput';
import ContentEditable from './ContentEditable';

const ThreadInput = ({ addThread }) => {
  const [title, onTitleChange, setTitle] = useInput('');
  const [category, onCategoryChange, setCategory] = useInput('');
  const [body, setBody] = React.useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (title === '') {
      toast.error('"title" is not allowed to be empty');
      return;
    }
    if (category === '') {
      toast.error('"category" is not allowed to be empty');
      return;
    }
    if (body === '') {
      toast.error('"body" is not allowed to be empty');
      return;
    }
    addThread({ title, category, body });
    setTitle('');
    setCategory('');
    setBody('');
  };

  return (
    <>
      <h2 className="font-bold text-xl tracking-wider text-[#808080] mb-4">Create a new Thread</h2>
      <form className="grid gap-[15px]" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="title" className="mb-2 block text-base font-medium text-black">
            Title
          </label>
          <input type="text" id="title" title="title" value={title} onChange={onTitleChange} className="w-full rounded-md border p-3 text-black placeholder-[#929DA7] outline-none transition focus:border-[#F48023] active:border-[#F48023] disabled:cursor-default disabled:bg-[#F5F7FD]" placeholder="Type your thread title ..." required />
        </div>
        <div>
          <label htmlFor="category" className="mb-2 block text-base font-medium text-black">
            Category
          </label>
          <input type="category" id="category" title="category" value={category} onChange={onCategoryChange} className="w-full rounded-md border p-3 text-black placeholder-[#929DA7] outline-none transition focus:border-[#F48023] active:border-[#F48023] disabled:cursor-default disabled:bg-[#F5F7FD]" placeholder="Type your thread category ..." required />
        </div>
        <div>
          <p className="mb-2 block text-base font-medium text-black">
            Body
          </p>
          <ContentEditable content={body} setContent={setBody} placeholder="Type your thread ..." />
        </div>
        <button type="submit" className="bg-[#F48023] py-3 rounded-md font-black text-white text-sm mt-5 tracking-wide">CREATE</button>
      </form>
    </>
  );
};

ThreadInput.propTypes = {
  addThread: PropTypes.func.isRequired,
};

export default ThreadInput;
